import { referenceCategories } from "./projectImages";
export const categoriesData = referenceCategories.map((cat,index) => ({...cat,id:index+1,src:cat.cover || "",titleKey:`category.${cat.name === "healthcare" ? "health" : cat.name}`,link:`/projects/${cat.name}`}));
